export const getElementParents = (target: HTMLElement): Array<HTMLElement> => {
  if (!target.parentElement) {
    return [];
  }

  return [target.parentElement, ...getElementParents(target.parentElement)];
};
